import { render } from "./UserDocumenti.vue?vue&type=template&id=7c98142c&scoped=true"
import script from "./UserDocumenti.vue?vue&type=script&lang=js"
export * from "./UserDocumenti.vue?vue&type=script&lang=js"

import "./UserDocumenti.vue?vue&type=style&index=0&id=7c98142c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c98142c"]])

export default __exports__